module.exports = __webpack_public_path__ + "img/4season-1.134a7bf3.png";